import { Helpers } from "../jobs-flow/Helpers";

export class CopyValueBtn {
    /**
     *
     * @param {String} btnClass
     * @param {String} valueClass
     * @param {String} parentSelector JS element selector (Example: ".class", "#id" etc.)
     */
    constructor(btnClass='copyValue', valueClass='valueContainer', parentSelector = 'div') {
        this.button = $(`.${btnClass}`);
        //this.parent = this.button.parents(parentSelector);
        //this.value = this.parent.find(`.${valueClass}`);
        this.parentSelector = parentSelector;
        this.valueClass = valueClass;
        this.initActions();
    }

    initActions(){
        this.button.click((e) => {
            const parent = $(e.currentTarget).parent(this.parentSelector);
            let value = parent.find(`.${this.valueClass}`);
            Helpers.selectElementContents(value[0]);
            $('#codeCopyMessage').css('z-index',100).css('opacity', 1);
            $('#codeCopyMessage').fadeIn(300, () => {
                setTimeout(() => {
                    $('#codeCopyMessage').fadeOut(300);
                }, 3000);
            });
        });
    }
}
